import { Grid } from '@mui/material';

import { useEffect, useState } from 'react';
import { getPlanStatusColor } from '../../../../../constants/Colors';
import { PlanFlat } from '../../../../../domain/plan/PlanFlat';
import { intl } from '../../../../../helpers/IntGlobalProvider';
import Text from '../../../../../react-components/Text';
import { PlanStatusIcon } from '../../../shared/PlanStatusIcon';
import { useManagePlanQuery } from '../../hooks/useManagePlanQuery';
import { PlanActionsMenu } from '../../PlanActionsMenu';
import { PlanCalendarEventProps } from '../PlanCalendarEventMapper';

interface CalendarEventProps {
  calendarEvent: PlanCalendarEventProps;
}

export const CalendarEvent = ({ calendarEvent }: CalendarEventProps) => {
  const { clearPlanQueries } = useManagePlanQuery();
  const [eventContextAnchor, setEventContextAnchor] = useState<
    | {
        top: number;
        left: number;
      }
    | undefined
  >(undefined);

  const plan = calendarEvent.plan;

  const handleCloseContextMenu = () => {
    setEventContextAnchor(undefined);
  };

  useEffect(() => {
    if (eventContextAnchor) {
      const handleClickOutside = (event: MouseEvent) => {
        handleCloseContextMenu();
      };

      document.addEventListener(`click`, handleClickOutside);
      return () => {
        document.removeEventListener(`click`, handleClickOutside);
      };
    }
    return () => {};
  }, [eventContextAnchor]);

  return (
    <>
      <Grid
        display="flex"
        flexDirection="row"
        alignItems="center"
        style={{
          backgroundColor: getPlanStatusColor(plan.status, `light`),
          border: `2px solid ${getPlanStatusColor(plan.status)}`,
          width: `100%`,
          padding: `2px 4px`,
          cursor: `pointer`,
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setEventContextAnchor({
            top: e.clientY,
            left: e.clientX,
          });
        }}
      >
        <PlanStatusIcon
          status={plan.status}
          style={{ height: `12px`, width: `12px`, marginRight: `6px`, cursor: `pointer` }}
          color={getPlanStatusColor(plan.status, `dark`)}
        />
        <Text
          variant="body"
          style={{
            color: getPlanStatusColor(plan.status, `dark`),
            width: `100%`,
            overflow: `hidden`,
            textOverflow: `ellipsis`,
            userSelect: `none`,
            cursor: `pointer`,
            opacity: plan.label ? 1 : 0.69,
          }}
        >
          {plan.label ?? intl.formatMessage({ id: `no_name` })}
        </Text>
      </Grid>

      {eventContextAnchor && (
        <PlanActionsMenu
          type="contextual"
          plans={[plan]}
          contextAnchor={{ screenPosition: eventContextAnchor }}
          onCloseAnyDialog={() => {
            setEventContextAnchor(undefined);
          }}
          onDeletePlan={(deletedPlans: Array<PlanFlat>) => {
            clearPlanQueries();
          }}
          onUpdatePlanStatus={() => {
            clearPlanQueries();
          }}
          onDuplicatePlan={() => {
            clearPlanQueries();
          }}
        />
      )}
    </>
  );
};
